import { useEffect, useState } from 'react';
import { fetchTronTransaction } from '../api/transactions';

export function useTronTransaction(hash) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const normalized = String(hash || '').trim().toLowerCase();
    if (!/^[a-f0-9]{64}$/.test(normalized)) {
      setData(null);
      setLoading(false);
      setError('Invalid Tron transaction hash.');
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);
    setData(null);

    fetchTronTransaction(normalized)
      .then((result) => {
        if (!cancelled) {
          setData(result);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(
            err.response?.data?.message ||
              err.message ||
              'Failed to load transaction.',
          );
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [hash]);

  return { data, loading, error };
}
